import './AddPage.scss';
import { Button, Card, Dropdown, Icon, Input, LabelValue, Textarea, Typography } from '@design-system/index';
import { Formik } from 'formik';
import { MemberTable } from '@services/member/member/member.types';
import { MembersListLine } from '@icons';
import { useAddPageVM } from './useAddPageVM';
import { AsyncDropdown, DropdownOption } from '@design-system/components/Dropdown/AsyncDropdown';
import { useGetMembersMutation } from '@services/member/member/member.endpoints';
import { TicketingToCreate } from '@services/member/ticketing/ticketing.types';
import { formatMoney } from '@utils/index';

export default function AddPage() {
    const { submitForm, isLoading, ticketing, isEdit, ticketTypes, member } = useAddPageVM();

    console.log("ticketing", ticketing);

    return (
        <div className="add-member-container">
            <Card
                isLoading={isLoading}
                headerType="full"
                showBack
                headerTitle={isEdit ? 'Modification vente billetterie' : 'Nouvelle vente billetterie'}
                headerIcon={<Icon icon={<MembersListLine />} size={20} color="primary" />}
            >
                <>
                    <Formik
                        initialValues={
                            ticketing
                                ? {
                                      ...ticketing,
                                      ticketingAt: ticketing.ticketingAt
                                          ? (() => {
                                                const d = new Date(ticketing.ticketingAt);
                                                const year = d.getFullYear();
                                                const month = String(d.getMonth() + 1).padStart(2, '0');
                                                const day = String(d.getDate()).padStart(2, '0');
                                                return `${year}-${month}-${day}`;
                                            })()
                                          : ''
                                  }
                                : ({
                                      member: member
                                          ? {
                                                id: member.id.toString(),
                                                label: member.cosemNumber + ' - ' + member.fullname
                                            }
                                          : null,
                                      ticketType: null,
                                      ticketingAt: new Date().toISOString().split('T')[0],
                                      saleAmount: 0,
                                      saleCount: 0,
                                      observation: '',
                                      bookNumber: '',
                                      firstTicketNumber: 0,
                                      lastTicketNumber: 0,
                                      amount: 0,
                                      isArchived: false
                                  } as unknown as TicketingToCreate)
                        }
                        enableReinitialize
                        onSubmit={async (values: TicketingToCreate) => {
                            await submitForm(values);
                        }}
                    >
                        {({ values, handleChange, handleSubmit, setFieldValue, isSubmitting }) => {
                            return (
                                <form onSubmit={handleSubmit} className="form">
                                    <div className="form-section-container">
                                        <div className="form-section" id="administrative-section">
                                            <Typography intrinsic="h3">Informations sur la vente</Typography>
                                            <div className="form-section-fields">
                                                <div className="form-line">
                                                    <div className="form-group">
                                                        <AsyncDropdown<MemberTable>
                                                            label="Rechercher un adhérent"
                                                            required
                                                            onOptionChange={(option) => {
                                                                setFieldValue('member', option);
                                                            }}
                                                            mutationHook={useGetMembersMutation}
                                                            mapDataToOptions={(data) =>
                                                                data.map((item) => ({
                                                                    id: item.id.toString(),
                                                                    label:
                                                                        item.cosemNumber +
                                                                        ' - ' +
                                                                        item.personalInformation.lastname +
                                                                        ' ' +
                                                                        item.personalInformation.firstname
                                                                }))
                                                            }
                                                            value={
                                                                values.member
                                                                    ? 'label' in values.member
                                                                        ? (values.member as unknown as DropdownOption)
                                                                        : {
                                                                              id: values.member.id?.toString() || '',
                                                                              label:
                                                                                  (values.member.cosemNumber || '') +
                                                                                  ' - ' +
                                                                                  (values.member.fullname || '')
                                                                          }
                                                                    : undefined
                                                            }
                                                            isSearchable
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <Dropdown
                                                            label="Type de billet"
                                                            required
                                                            isSearchable
                                                            value={values.ticketType}
                                                            options={ticketTypes.map((type) => ({ id: type.id, label: type.label }))}
                                                            onOptionChange={(option) => {
                                                                setFieldValue('ticketType', option);
                                                                setFieldValue(
                                                                    'amount',
                                                                    ticketTypes.find((t) => t.id === option.id)?.amount ?? 0
                                                                );
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <Input
                                                            type="date"
                                                            required
                                                            name="ticketingAt"
                                                            label="Date de la vente"
                                                            value={values.ticketingAt}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-line">
                                                    <div className="form-group">
                                                        <Input
                                                            label="Numéro du premier billet"
                                                            name="firstTicketNumber"
                                                            value={values.firstTicketNumber}
                                                            required
                                                            type="number"
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <Input
                                                            label="Numéro du dernier billet"
                                                            name="lastTicketNumber"
                                                            value={values.lastTicketNumber}
                                                            required
                                                            type="number"
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <Input
                                                            type="number"
                                                            label="Prix du billet"
                                                            name="amount"
                                                            rightContent={'€'}
                                                            value={values.amount}
                                                            required
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-line bordered">
                                                    <div className="form-group">
                                                        <LabelValue label="Nombre de billets" value={Number(values.lastTicketNumber) - Number(values.firstTicketNumber) + 1} />
                                                    </div>
                                                    <div className="form-group">
                                                        <LabelValue
                                                            label="Montant total"
                                                            value={formatMoney(Number(values.amount) * (Number(values.lastTicketNumber) - Number(values.firstTicketNumber) + 1))}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-line">
                                                    <div className="form-group">
                                                        <Textarea
                                                            label="Ajouter un commentaire"
                                                            name="observation"
                                                            value={values.observation}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="action-buttons">
                                        <Button type="submit" disabled={isSubmitting} variant="primary">
                                            {isEdit ? 'Valider la modification' : 'Valider la création'}
                                        </Button>
                                    </div>
                                </form>
                            );
                        }}
                    </Formik>
                </>
            </Card>
        </div>
    );
}
